import ingresoCitas from "./ingresoCitas";
import verCita from "./verCita";

export default {

  modules: {
    ingresoCitas,
    verCita
  }

};